module.exports = __webpack_public_path__ + "static/media/vietnam-gray.5c5c7f38.svg";